export interface CommentItem {
  id: string;
  movieId: string;
  user: string;
  avatarColor: string;
  time: string;
  content: string;
  likes: number;
}

export const comments: CommentItem[] = [
  {
    id: 'c01',
    movieId: 'm01',
    user: '雨夜不睡',
    avatarColor: 'primary',
    time: '2 小时前',
    content: '长镜头那段真的看得我屏住呼吸，雨声一整段没停，太狠了。',
    likes: 128,
  },
  {
    id: 'c02',
    movieId: 'm01',
    user: '阿野的观众',
    avatarColor: 'accent',
    time: '5 小时前',
    content: '以为是普通刑侦片，结果看到最后有点想哭。老搭档那条线处理得很克制。',
    likes: 86,
  },
  {
    id: 'c03',
    movieId: 'm01',
    user: '胶片收藏家',
    avatarColor: 'secondary',
    time: '昨天',
    content: '画面调色非常舒服，暗部细节还在，不是那种一味压黑的做法。',
    likes: 54,
  },
  {
    id: 'c04',
    movieId: 't01',
    user: '长安路人甲',
    avatarColor: 'accent',
    time: '3 小时前',
    content: '西市的实景太顶了，连摊子上的胡饼都像真的。',
    likes: 203,
  },
  {
    id: 'c05',
    movieId: 't01',
    user: '看剧不睡觉',
    avatarColor: 'primary',
    time: '8 小时前',
    content: '裴照这个角色写得好，不是天才，只是不肯放过细节。',
    likes: 97,
  },
  {
    id: 'c06',
    movieId: 'v01',
    user: '耳机已报废',
    avatarColor: 'secondary',
    time: '1 小时前',
    content: '现场不修音真的敢，第二期那个高音破了一点反而更好听。',
    likes: 156,
  },
];